var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{staticClass:"mt-3"},[_c('b-col',[_c('div',[_vm._v("U hebt geen toegang tot deze functie."),_c('br'),_vm._v("Kies een van de opties uit het menu om verder te gaan.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }